<template>
  <d-container
    fluid
    class="main-content-container px-0 px-md-2 px-lg-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        sm="12"
        md="9"
        lg="9"
        class="text-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Produkty</span>
        <h3 class="page-title">Lista produktów</h3>
      </d-col>
      <d-col
        col
        sm="12"
        md="3"
        lg="3"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <!-- <d-button
          theme="success"
          @click.prevent="$router.push('/produkty/nowy')">
          <i class="material-icons">add</i>
          Dodaj produkt
        </d-button> -->
      </d-col>
    </d-row>

    <d-row
      v-if="loaded"
      style="width: 100%"
      class="d-flex ml-0 mb-0 page-filters">
      <validation-observer
        ref="products-filters-form"
        tag="form"
        style="width: 100%"
        class="d-flex">
        <d-input
          placeholder="Podaj nazwę lub numer EAN produktu"
          v-model="filters.search"
          class="mr-1 mb-2"
          style="min-width: 290px;" />

        <v-select
          style="width: 360px; min-width: 150px; max-width: 30%;"
          class="mr-1 mb-2"
          :options="allManufacturers"
          v-model="filters.manufacturerID"
          :reduce="(manufacturer) => manufacturer.id"
          placeholder="Producent"
          :searchable="true"
          :filterBy="filterByForManufacturers"
          :disabled="!loadedManufacturers"
          label="name"
          @search="debouncedFetchManufacturers">
          <template slot="no-options">
            <template v-if="!manufacturersEmptyResults">Trwa wyszukiwanie&hellip;</template>
            <template v-else>Brak producentów pasujących do podanej frazy&hellip;</template>
          </template>
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>

        <v-select
          style="width: 360px; min-width: 150px; max-width: 30%;"
          class="mr-1 mb-2"
          :options="allCategories"
          v-model="filters.categoryID"
          :reduce="(category) => category.id"
          placeholder="Kategoria"
          :searchable="true"
          :filterBy="filterByForCategories"
          :disabled="!loadedCategories"
          label="name"
          @search="debouncedFetchCategories">
          <template slot="no-options">
            <template v-if="!categoriesEmptyResults">Trwa wyszukiwanie&hellip;</template>
            <template v-else>Brak kategorii pasujących do podanej frazy&hellip;</template>
          </template>
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name }}
            </div>
          </template>
        </v-select>

        <v-select
          style="width: 360px; min-width: 150px; max-width: 30%;"
          class="mr-1 mb-2"
          :options="productAvailabilityOptions"
          :reduce="(availability) => availability.value"
          v-model="filters.availability"
          placeholder="Produkty dostępne?"
          :searchable="false"
          label="text">
        </v-select>

        <d-button
          theme="info"
          outline
          class="text-nowrap ml-md-auto mr-1 mb-2"
          @click.prevent="validateFiltersForm">
          Szukaj
        </d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap mb-2"
          @click.prevent="clearFilters">
          Resetuj filtry
        </d-button>
      </validation-observer>
    </d-row>

    <d-card style="width: 100%">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0 align-middle">Zdjęcie</th>
            <th scope="col" class="border-0 align-middle">Produkt</th>
            <th scope="col" class="border-0 align-middle text-center">Cena brutto</th>
            <th scope="col" class="border-0 align-middle text-center">Stawka VAT</th>
            <th scope="col" class="border-0 align-middle text-center">Dostępność</th>
            <th scope="col" class="border-0 align-middle text-center" style="width: 150px;">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr v-for="(product, index) of products" :key="'product-' + index">
            <td class="align-middle py-lg-1 py-md-3 py-3">
              <label class="table-mobile-label mb-1">Zdjęcie</label>
              <img
                v-if="product.image_url"
                class=""
                style="
                  min-width: 100px;
                  min-height: 100px;
                  max-width: 100px;
                  max-height: 100px;
                  object-fit: contain;
                "
                :src="product.image_url"
                alt="">
              <div
                v-if="!product.image_url"
                class="no-image">
                  <i class="material-icons">no_photography</i>
              </div>
            </td>
            <td class="align-middle text-left py-lg-1 py-md-3 py-3">
              <label class="table-mobile-label mb-1">Produkt</label>
              <strong>{{ product.name }}</strong>
              <template v-if="product.type === 'VARIANT'">
                <br>
                <d-badge theme="primary">Produkt z wariantami</d-badge>
              </template>
              <br>
              <small>
                <strong>Kod EAN: </strong>
                <template v-if="product.code">{{ product.code }}</template>
                <template v-else>-</template>
              </small>
              <template v-if="product.category_id">
                <br>
                <small>
                  <strong>Kategoria: </strong>
                  {{ product.category.name }}
                </small>
              </template>
              <template v-if="product.manufacturer_id">
                <br>
                <small>
                  <strong>Producent: </strong>
                  {{ product.manufacturer.name }}
                </small>
              </template>
            </td>
            <td class="align-middle text-center py-lg-1 py-md-3 py-3">
              <label class="table-mobile-label mb-1">Cena brutto</label>
              {{ roundProperly(product.price) }} zł
            </td>
            <td class="align-middle text-center py-lg-1 py-md-3 py-3">
              <label class="table-mobile-label mb-1">Stawka VAT</label>
              {{ product.vat_rate }}%
            </td>

            <td class="align-middle text-center py-lg-1 py-md-3 py-3">
              <label class="table-mobile-label mb-1">Dostępność</label>
              <span v-if="product.availability === 1" class="text-success">
                TAK<br>
                <small v-if="product.type === 'SIMPLE'">({{ product.stock }} szt.)</small>
                <small v-if="product.type === 'VARIANT'">({{ product.children_sum_stock }} szt.)</small>
              </span>
              <span v-else class="text-danger">
                NIE
              </span>
            </td>

            <td class="text-center align-middle pt-0">
              <d-button
                theme="primary"
                @click.native="$router.push('/produkty/edycja/' + product.id)"
                class="mx-2 mt-2"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <!-- <d-button
                theme="danger"
                :disabled="product.id === removeInProgress"
                @click.native="removeProduct(product.id)"
                title="Usuń"
                class="mx-2 mt-2">
                <i class="material-icons">delete</i>
              </d-button> -->
            </td>
          </tr>
          <tr v-if="products.length === 0">
            <td
              colspan="6"
              class="text-center">
              Brak produktów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się.
        <a
          href="javascript:window.location.reload();"
          class="alert-link">
          Odśwież stronę
        </a>
        aby spróbować ponownie.
      </d-alert>
    </d-card>

    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';
import CustomDecimals from './../utils/CustomDecimals.js';

export default {
  name: 'products',
  mixins: [HasFilters, HasPagination],
  components: {
    pagination: Pagination,
  },
  computed: {
    productAvailabilityOptions() {
      return [
        {
          text: 'Dowolna dostępność',
          value: '',
        },
        {
          text: 'Produkty dostępne',
          value: '1',
        },
        {
          text: 'Produkty niedostępne',
          value: '0',
        },
      ];
    },
  },
  data() {
    return {
      products: [],
      allManufacturers: [],
      allCategories: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      manufacturersEmptyResults: false,
      categoriesEmptyResults: false,
      loadedManufacturers: false,
      loadedCategories: false,
      filters: {
        search: '',
        availability: null,
        manufacturerID: null,
        categoryID: null
      },
    };
  },
  mounted() {
    this.loadFilteredData();
    this.loadAdditionalData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData() {
      let where = {};

      if (this.filters.search) {
        where.search = this.filters.search;
      }

      if (this.filters.availability !== null) {
        where.availability = this.filters.availability;
      }

      if (this.filters.manufacturerID) {
        where.manufacturer_id = this.filters.manufacturerID;
      }

      if (this.filters.categoryID) {
        where.category_id = this.filters.categoryID;
      }

      ListUtils.loadItemsData(this, {
        method: 'get',
        endpoint: '/api/products/items?page=' + this.currentPage,
        listField: 'products',
        pagination: true,
        params: {
          where,
        }
      });
    },
    loadAdditionalData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/manufacturers/items',
        method: 'get',
        outputKey: 'allManufacturers',
        loadedKey: 'loadedManufacturers',
        errorKey: 'loadError',
        params: {
          pagination: 0,
        }
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/categories/items',
        method: 'get',
        outputKey: 'allCategories',
        loadedKey: 'loadedCategories',
        errorKey: 'loadError',
        params: {
          pagination: 0,
        }
      });
    },
    clearFilters() {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        availability: null,
        manufacturerID: null,
        categoryID: null
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    validateFiltersForm() {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(
        this.$refs['products-filters-form'],
        this.debouncedLoadFilteredData
      );
    },
    removeProduct(productID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/api/products/delete/',
        id: productID,
        successTitle: 'Usunięto produkt',
        successText: 'Wybrany produkt został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten produkt?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie produktu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
      });
    },
    roundProperly (value, decimals = 2) {
      return CustomDecimals.roundProperly(value, decimals);
    },
    filterByForManufacturers (option, label, search) {
      return (option.name).toLocaleLowerCase('pl').indexOf(search.toLocaleLowerCase('pl')) > -1;
    },
    fetchManufacturers (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/api/manufacturers/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.filters.manufacturerID !== 0 && this.filters.manufacturerID !== null && searchPhrase === '') {
        endpointUrl = '/api/manufacturers/item/' + parseInt(this.filters.manufacturerID, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'allManufacturers',
        errorKey: 'loadError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.manufacturersEmptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchManufacturers: debounce(function (searchPhrase, loadingCallback) {
      this.fetchManufacturers(searchPhrase, loadingCallback);
    }, 500),
    filterByForCategories (option, label, search) {
      return (option.name).toLocaleLowerCase('pl').indexOf(search.toLocaleLowerCase('pl')) > -1;
    },
    fetchCategories (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/api/categories/items';
      let responseAsArray = false;
      let paramsData = {};

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase
        };
      }

      if (this.filters.categoryID !== 0 && this.filters.categoryID !== null && searchPhrase === '') {
        endpointUrl = '/api/categories/item/' + parseInt(this.filters.categoryID, 10);
        responseAsArray = true;
      }

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'allCategories',
        errorKey: 'loadError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.categoriesEmptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchCategories: debounce(function (searchPhrase, loadingCallback) {
      this.fetchCategories(searchPhrase, loadingCallback);
    }, 500),
  },
};
</script>

<style lang="scss">
.no-image {
    background-color: #eeeeee;
    border-radius: 6px;
    height: 100px;
    width: 100px;

    i {
        color: #ADADAD;
        font-size: 40px;
        position: relative;
        text-align: center;
        top: 49%;
        transform: translateY(-50%);
        width: 100%;
    }
}
</style>
